import React, { useEffect, useState } from 'react';
import { useParams , Link } from 'react-router-dom';
import axios from 'axios';
interface NewsItem {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
}

const SearchResults = () => {
     const api = process.env.REACT_APP_API_URL as string;
  const { keyword } = useParams();
  const [results, setResults] = useState<NewsItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get(`${api}/auth/news/search/${keyword}`);
        setResults(response.data);
        setError('');
      } catch (err: any) {
        setResults([]);
        if (err.response?.status === 404) {
          setError('No news found');
        } else {
          setError('Something went wrong');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [keyword]);

 return (
    <div className="p-6 max-w-7xl mx-auto">
      <h1 className="text-3xl font-bold text-blue-700 mb-6">
        Search Results for <span className="italic">"{keyword}"</span>
      </h1>

      {loading && <p className="text-gray-500">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {results.map((item) => (
          <div
            key={item.id}
            className="bg-white border rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
          >
            {item.img && (
              <img
                src={`${api}/${item.img}`}
                alt={item.title}
                className="h-48 w-full object-cover"
              />
            )}
            <div className="p-4 flex flex-col h-full">
              <h2 className="text-lg font-semibold text-gray-800 line-clamp-2">{item.title}</h2>
              <p className="text-sm text-gray-500 mt-1">
  {new Date(item.date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })}
</p>

              <p className="text-gray-600 mt-2 line-clamp-3">{item.content}</p>
              <div className=" pt-4">
                <Link
  to={`/news/${item.id}`}
  className="inline-block text-sm text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded transition"
>
  Read More
</Link>

              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
